"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var getClauseSectionProperties_1 = require("../actions/helpers/getClauseSectionProperties");
var getClauseIdsForSectionType_1 = require("../actions/helpers/getClauseIdsForSectionType");
function isValidClause(clauseId) {
    var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
    var clauseValue = clause.clauseValue;
    // if clause type hasn't been selected from dropdown or value hasn't been input yet
    if (!clause.clauseType) {
        return false;
    }
    switch (clause.clauseType) {
        case 'from':
        case 'to':
        case 'forwardTo':
        case 'forwardAsAttachmentTo':
        case 'redirectTo':
            // check if recipient well is empty
            var recipientWell = clauseValue;
            return recipientWell.recipients.length != 0;
        case 'subjectIncludes':
        case 'subjectOrBodyIncludes':
        case 'inTheBody':
        case 'inTheSenderAddress':
        case 'inTheRecipientAddress':
        case 'inTheMessageHeader':
            // check if includes words input is empty
            var phrasePills = clauseValue;
            return phrasePills.length != 0;
        case 'moveTo':
        case 'copyTo':
            // check if folder has been selected
            var selectedFolder = clauseValue;
            return selectedFolder != null && selectedFolder.folderId != null;
        case 'atLeast':
        case 'atMost':
            var messageSize = clauseValue;
            return !isNaN(messageSize) && messageSize <= 1000000 && messageSize >= 0;
        case 'category':
        case 'fromTheAccount':
        case 'withImportance':
        case 'markImportance':
        case 'sensitivity':
        case 'classification':
        case 'flag':
        case 'type':
            return clauseValue != null;
        case 'onTheToOrCcLine':
        case 'theOnlyRecipientListed':
        case 'onTheToLine':
        case 'onTheCcLine':
        case 'notOnTheToLine':
        case 'delete':
        case 'pin':
        case 'read':
        case 'junk':
        case 'attachment':
        case 'before':
        case 'after':
            return true;
        default:
            throw new Error('Cannot validate unknown clause type');
    }
}
exports.default = isValidClause;
function isValidSection(sectionType) {
    var sectionProperties = getClauseSectionProperties_1.default(sectionType);
    var clauseIds = getClauseIdsForSectionType_1.default(sectionType);
    var isValidClauseInSection = false;
    // Valid sections:
    // 1: Required sections with an unselected clause with at least one other valid clause in the section
    // 2: Optional sections with an unselected clause type
    // 3: Sections with all valid clauses
    for (var _i = 0, clauseIds_1 = clauseIds; _i < clauseIds_1.length; _i++) {
        var clauseId = clauseIds_1[_i];
        var clause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        if (!clause.clauseType && (isValidClauseInSection || sectionProperties.isOptional)) {
            return true;
        }
        if (!isValidClause(clauseId)) {
            return false;
        }
        isValidClauseInSection = true;
    }
    // we've checked every clause by this point
    return true;
}
exports.isValidSection = isValidSection;
//# sourceMappingURL=isValidClause.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/utils/isValidClause.js
// module id = 3078
// module chunks = 2